import styled from 'styled-components/macro';
import { ButtonLink } from '@yme/molecules/buttons';
import { BG_GRADIENT_NEWSLETTER } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { transformSrcSetToCss } from '@yme/utils/styles';
export const BackgroundImageStyled = styled.div `
  height: 202px;

  ${({ srcSet, src }) => transformSrcSetToCss(srcSet, src, BG_GRADIENT_NEWSLETTER)}

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${ADAPTIVE.minWidth.tablet} {
    height: calc(100vh - 540px);
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: 810px;
  }
`;
export const ButtonLinkStyled = styled(ButtonLink) `
  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
  }
`;
